(function () {
  'use strict';
  var MAX_DIM = 1500;
  var MAX_BYTES = 1024 * 1024;
  var SKIP_BYTES = 300 * 1024;
  var pending = 0;
  var queuedForm = null;

  function flush() {
    if (pending === 0 && queuedForm) {
      var f = queuedForm;
      queuedForm = null;
      if (f.requestSubmit) {
        f.requestSubmit();
      } else {
        f.submit();
      }
    }
  }

  document.addEventListener(
    'submit',
    function (e) {
      if (
        pending > 0 &&
        e.target &&
        e.target.querySelector &&
        e.target.querySelector('input[type="file"][name^="properties["]')
      ) {
        e.preventDefault();
        e.stopImmediatePropagation();
        queuedForm = e.target;
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (e) {
      var inp = e.target;
      if (!inp || inp.type !== 'file' || !inp.name || inp.name.indexOf('properties[_Team Logo') !== 0) return;
      var f = inp.files && inp.files[0];
      if (!f || !/^image\/(png|jpe?g|webp)$/i.test(f.type)) return;
      if (f.size < SKIP_BYTES) return;
      if (typeof DataTransfer === 'undefined' || typeof File === 'undefined') return;
      pending++;
      var url = URL.createObjectURL(f);
      var img = new Image();
      var finished = false;
      function done() {
        if (finished) return;
        finished = true;
        URL.revokeObjectURL(url);
        pending--;
        flush();
      }
      img.onload = function () {
        try {
          var w = img.naturalWidth;
          var h = img.naturalHeight;
          if (!w || !h) return done();
          var scale = Math.min(1, MAX_DIM / Math.max(w, h));
          if (scale === 1 && f.size <= MAX_BYTES) return done();
          var cw = Math.max(1, Math.round(w * scale));
          var ch = Math.max(1, Math.round(h * scale));
          var cv = document.createElement('canvas');
          cv.width = cw;
          cv.height = ch;
          var ctx = cv.getContext('2d');
          if (!ctx) return done();
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.drawImage(img, 0, 0, cw, ch);
          var keepAlpha = /png|webp/i.test(f.type);
          var outType = keepAlpha ? 'image/png' : 'image/jpeg';
          cv.toBlob(
            function (b) {
              try {
                if (b && b.size < f.size) {
                  var name = f.name.replace(/\.[a-z0-9]+$/i, keepAlpha ? '.png' : '.jpg');
                  var nf = new File([b], name, { type: outType });
                  var dt = new DataTransfer();
                  dt.items.add(nf);
                  inp.files = dt.files;
                }
              } catch (err) {}
              done();
            },
            outType,
            0.9
          );
        } catch (err) {
          done();
        }
      };
      img.onerror = done;
      img.src = url;
    },
    true
  );
})();
